import { Anchor, Breadcrumbs, Container } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { AssignmentForm } from '@/frontend/components/marina/AssignmentForm'
import { useCreateAssignment } from '@/frontend/hooks/useAssignments'

export const Route = createFileRoute('/dashboard/facility/assignments/new')({
  component: NewAssignment,
})

function NewAssignment() {
  const navigate = useNavigate()
  const create = useCreateAssignment()

  return (
    <Container size="xl" py="md">
      <Breadcrumbs mb="md">
        <Anchor component={Link} to="/dashboard/facility/assignments" c="dimmed">
          Assignments
        </Anchor>
        <span>New</span>
      </Breadcrumbs>

      <AssignmentForm
        submitLabel="Create"
        submitting={create.isPending}
        onCancel={() => navigate({ to: '/dashboard/facility/assignments' })}
        onSubmit={async (values) => {
          try {
            const { assignment } = await create.mutateAsync(values)
            notifications.show({
              title: 'Assignment created',
              message: assignment.title,
              color: 'teal',
            })
            navigate({ to: '/dashboard/facility/assignments' })
          } catch (e: unknown) {
            notifications.show({
              title: 'Failed',
              message: e instanceof Error ? e.message : 'Try again',
              color: 'red',
            })
          }
        }}
      />
    </Container>
  )
}
